import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Storage } from 'react-jhipster';

import ptBR from './locales/pt-br.json';
import en from './locales/en.json';

const normalizeBundle = (bundle: unknown) => {
    if (bundle && typeof bundle === 'object' && 'default' in (bundle as Record<string, unknown>)) {
        return (bundle as { default: Record<string, unknown> }).default;
    }
    return bundle as Record<string, unknown>;
};

const getInitialLocale = () => {
    const stored = Storage.session.get('locale', 'pt-br') as string;
    return stored === 'en' ? 'en' : 'pt-br';
};

i18n.use(initReactI18next).init({
    resources: {
        'pt-br': { translation: normalizeBundle(ptBR) },
        'pt-BR': { translation: normalizeBundle(ptBR) },
        en: { translation: normalizeBundle(en) }
    },

    lng: getInitialLocale(),
    fallbackLng: 'pt-br',
    supportedLngs: ['pt-br', 'pt-BR', 'en'],
    load: 'currentOnly',

    ns: ['translation'],
    defaultNS: 'translation',
    keySeparator: '.',
    nsSeparator: ':',
    initImmediate: false,
    debug: process.env.NODE_ENV === 'development',

    interpolation: { escapeValue: false },
    returnNull: false
});

export default i18n;
